import { Component } from '@angular/core';

@Component({
  selector: 'jb-main-skeleton',
  templateUrl: './main-skeleton.component.html',
})
export class MainSkeletonComponent {}
